// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"jr-z","tooltipWrapper":"kr-z","icon":"lr-z","tooltip":"mr-z","content":"nr-z"};